const texts = {
  default: {
    title: "pages.landing.eVoucher.title",
    text: "pages.landing.eVoucher.text",
    subscriptions: "",
    paragraph1: "pages.landing.eVoucher.instructions.paragraph1",
    paragraph2: "pages.landing.eVoucher.instructions.paragraph2",
    paragraph3: "pages.landing.eVoucher.instructions.paragraph3",
    join: "global.eVoucher.join",
    start: "global.eVoucher.start",
    notNow: "pages.landing.sCouponCode.notNow",
    disclaimer: "global.eVoucher.disclaimer"
  },
  sCouponCode: {
    title: "pages.landing.sCouponCode.title",
    text: "pages.landing.sCouponCode.text",
    subscriptions: "pages.landing.sCouponCode.subscriptions",
    paragraph1: "pages.landing.sCouponCode.instructions.paragraph1",
    paragraph2: "pages.landing.sCouponCode.instructions.paragraph2",
    paragraph3: "pages.landing.sCouponCode.instructions.paragraph3",
    join: "pages.landing.sCouponCode.join",
    start: "pages.landing.sCouponCode.start",
    notNow: "pages.landing.sCouponCode.notNow",
    disclaimer: "pages.landing.sCouponCode.disclaimer"
  }
};

export function getLandingTexts(sCouponCode) {
  const key = "sCouponCode";
  return texts[key];
}
